import { QueryClient } from "@tanstack/react-query";
import { SKILLS_QUERIES } from "~/shared/api/skills/skills.queries";

export async function utahOnboardingTaxonomyLoader(queryClient: QueryClient) {
  queryClient.prefetchInfiniteQuery(SKILLS_QUERIES.infiniteList({ limit: 75 }));

  return null;
}
